import * as React from "react";
import { Adviser } from "../../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { NetworkType } from "../../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { FirmType } from "../../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { CompanyDetailSort } from "../../../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { titleLabels } from "../../Resource/Contents";
import { IAddClientModel } from "../AddClientWizard";
import { SearchInput } from "../../../../../../Shared/SearchInput/SearchInput";
import { NetworkHistoryClient } from "../../../../../../../Wrap/Api/Network/NetworkHistory";
import { NetworkHistoryModel } from "../../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { CompanySearchClient } from "../../../../../../../Wrap/Api/Company/CompanySearch";
import { CompanySummary } from "../../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { validationMessage } from "../../Resource/Validation";
import { AdviserWizardAction } from "../../../../../../Admin/Adviser/Actions/AdviserWizardAction";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { AddClientAction } from "../../Actions/AddClientAction";

interface IFilterProps extends IProcessComponentProps {
    onFilterSelectionChange: (changes: IAddClientModel) => void;
    excludeAdviser?: boolean;
    onOneDefaultCompany?: (company: CompanySummary) => void;
    adviserOptional?: boolean;
    ReadWriteAccessAdviserOnly?: boolean;
}

export const enum SelectionType {
    Adviser,
    Network,
    Firm,
}

interface IFilterState {
    isAdminUser: boolean;
    selectNetwork: NetworkHistoryModel;
    selectAdviser: Adviser;
    selectFirm: CompanySummary;
    advisers: Adviser[];
    displayNetworkSearch: boolean;
    displayCompanySearch: boolean;
}

export class Filter extends ProcessComponent<IFilterProps, IFilterState> {
    constructor(props: any) {
        super(props);
        this.state = this.getDefaultState();
    }

    private getDefaultState() {
        return {
            isAdminUser: ContextStore.getContext().isAdminUser,
            selectNetwork: this.props.data?.SelectedNetwork || null,
            selectAdviser: this.props.data?.SelectedAdviser || null,
            selectFirm: this.props.data?.SelectedFirm || null,
            advisers: [],
            displayNetworkSearch: false,
            displayCompanySearch: true,
        } as IFilterState;
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data?.SelectedFirm || this.props.data?.SelectedNetwork) {
            this.getAdviser(this.props.data?.SelectedNetwork?.Network, this.props.data?.SelectedFirm?.CompanyCode);
        }

        const networkClient = new NetworkHistoryClient();
        networkClient.get(null, NetworkType.Network, null, null, null, false, 10, 1).onSuccess((result) => {
            if (result.TotalRows > 1) {
                this.setState({ displayNetworkSearch: true });
            }
        });

        const companyClient = new CompanySearchClient();
        companyClient
            .get(null, null, FirmType.All, null, null, null, true, 1, 10, CompanyDetailSort.CompanyName,false)
            .onSuccess((result) => {
                if (result.TotalNumberOfResults > 1) {
                } else if (result.TotalNumberOfResults == 1) {
                    this.getAdviser(null, result.PageOfResults[0].CompanyCode);
                    this.setState({ selectFirm: result.PageOfResults[0], displayCompanySearch: false });
                    if (this.props.onOneDefaultCompany) {
                        this.props.onOneDefaultCompany(result.PageOfResults[0]);
                    }
                }
            });
    }

    private getAdviser(network, company) {
        if (CommonHelper.isNullOrEmpty(company) && CommonHelper.isNullOrEmpty(network)) {
            this.setState({ advisers: [] });
        } else {
            const query = {
                Company: company,
                Network: network,
                CurrentPage: 1,
                ResultsPerPage: 999,
                ReadWriteOnly: false,
            };
            if (this.props.ReadWriteAccessAdviserOnly == true) {
                query.ReadWriteOnly = true;
            }
            AdviserWizardAction.getAdviser(query, (result) => {
                this.setState({ advisers: result.Results });
            });
        }
    }

    render() {
        const networkClient = new NetworkHistoryClient();
        const companyClient = new CompanySearchClient();
        const { advisers } = this.state;
        return (
            <>
                {this.state.displayNetworkSearch && (
                    <SearchInput
                        apiClient={(v) => {
                            return networkClient.get(null, NetworkType.Unknown, v, null, null, false, 20, 1);
                        }}
                        onClick={(v) => {
                            if (!v) {return;}
                            this.props.onFilterSelectionChange({
                                SelectedNetwork: v,
                                SelectedFirm: null,
                                SelectedAdviser: null,
                                Prospect: { ...this.props.data?.Prospect, OwnerAdviserId: null },
                                Organisation: { ...this.props.data?.Organisation, OwnerAdviserId: null },
                            });
                            this.getAdviser(v?.Network, null);
                            this.setState({ selectNetwork: v, selectFirm: null });
                        }}
                        resultKey="networks"
                        getText={(v: NetworkHistoryModel) => v.NetworkName}
                        cssWrapper="control-size-430"
                        label={titleLabels.networkLabel}
                        value={this.state.selectNetwork?.NetworkName}
                    />
                )}
                {this.state.displayCompanySearch && (
                    <SearchInput
                        apiClient={(v) => {
                            return companyClient.get(
                                null,
                                v,
                                FirmType.All,
                                null,
                                this.state.selectNetwork?.Network,
                                null,
                                true,
                                1,
                                20,
                                CompanyDetailSort.CompanyName,
                                false
                            );
                        }}
                        resultKey={"PageOfResults"}
                        onClick={(v: CompanySummary) => {
                            if (!v) {return;}
                            AddClientAction.getCompanyProposition(v.HierarchyId, (data) => {
                                this.props.onFilterSelectionChange({
                                    SelectedFirmProposition: data,
                                });
                            });

                            this.props.onFilterSelectionChange({
                                SelectedFirm: v,
                                SelectedAdviser: null,
                                Prospect: { ...this.props.data?.Prospect, OwnerAdviserId: null },
                                Organisation: { ...this.props.data?.Organisation, OwnerAdviserId: null },
                            });
                            this.getAdviser(this.state.selectNetwork?.Network, v?.CompanyCode);
                            this.setState({ selectFirm: v });
                        }}
                        getText={(v: CompanySummary) => v.CompanyName}
                        cssWrapper="control-size-430"
                        label={titleLabels.firmLabel}
                        value={this.state.selectFirm?.CompanyName}
                    />
                )}
                {!this.props.excludeAdviser && (
                    <SelectEditor
                        cssWrapper="control-size-430"
                        options={
                            advisers
                                ? advisers.map((x) => {
                                      return x.AdvisorId;
                                  })
                                : []
                        }
                        getText={(option) => {
                            return advisers.filter((x) => x.AdvisorId === option)[0].Name;
                        }}
                        placeholder={titleLabels.selectAdviser}
                        label={titleLabels.adviserLabel}
                        selected={
                            this.props.data && this.props.data.Prospect ? this.props.data.Prospect.OwnerAdviserId : null
                        }
                        onChange={(value) => {
                            this.props.onFilterSelectionChange({
                                Prospect: { ...this.props.data?.Prospect, OwnerAdviserId: value },
                                Organisation: { ...this.props.data?.Organisation, OwnerAdviserId: value },
                            });
                        }}
                        required={this.props.adviserOptional ? null : validationMessage.adviserValidation}
                    />
                )}
            </>
        );
    }
}
